export default __webpack_public_path__ + "static/media/featured-two.2d543cd1.png";